<template>
  <div class="container-fluid mt-2">
    <h2>Remote Services</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <button @click="showRegistry()" class="btn btn-secondary">Service Registry</button>
      <button @click="addService()" class="btn btn-primary">Hinzuf&uuml;gen</button>
    </div>
    <b-table @row-clicked="openService" class="mt-3" striped hover :items="rows" :fields="fields">
    </b-table>
    <b-modal id="serviceRegistry">
      <BFlowRemoteServiceSelector :registry="registry"/>
    </b-modal>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import router from '../../router'
import BFlowRemoteServiceSelector from '@/components/digitalfirm/BFlowRemoteServiceSelector.vue'

export default {
  components: {
    BFlowRemoteServiceSelector
  },
  data() {
    return {
      rows: [],
      registry: {},
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'key', label: 'Key' },
        { key: 'description', label: 'Beschreibung' },
      ]
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var self = this;
      fetch(config.baseUrl + 'rest/remoteservices/services?start=0&count=100').then(resp => resp.json()).then(function(data) {
        console.log(data);
        self.rows = data;
      })
    },
    addService() {
      console.log('add service');
      router.push({ name: 'RemoteServiceEditor' , params: { id: 'new' }});
    },
    openService(row) {
      router.push({ name: 'RemoteServiceEditor' , params: { id: row.key }});
    },
    showRegistry() {
      var self = this;
      fetch(config.baseUrl + 'rest/remoteservices/registry').then(resp => resp.json()).then(function(data) {
        console.log('registry',data);
        self.registry = data;
        self.$bvModal.show('serviceRegistry');
      })
    }
  }
}
</script>
